import { reactive, ref, computed, watch, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import * as common from '@/util/common'
import * as validation from '@/util/validation'
import * as apiQA from '@/api/qa'
import * as apiCommon from '@/api/common'
import * as logicCommonQA from '@/logic/common/CommonQA'
import * as _ from 'lodash'
import { getSearchTextInputOfSearchUIParam, getIsFuzzyInputOfSearchUIParam } from '@/util/search-ui'

/**
 * 詳細検索ウィンドウ
 */
export const getGroup = (props, context) => {

  onBeforeMount(() => {

    const searchCategory = store.state.search.searchCategory

    // 詳細検索ウィンドウ表示したタイミングでの値保持用
    group1.keyword_search_text = getSearchTextInputOfSearchUIParam(searchCategory)
    group1.is_fuzzy = getIsFuzzyInputOfSearchUIParam(searchCategory)

    // 入力フォームのデータバインディング用
    group1.keyword_search_text_input = getSearchTextInputOfSearchUIParam(searchCategory)
    group1.is_fuzzy_input = getIsFuzzyInputOfSearchUIParam(searchCategory)

    // QA一覧画面に対する遷移元の名前
    group1.fromNameForQAList = store.state.qa.fromNameForQAList
    // 保存検索条件画面、検索履歴画面から遷移した時に保持される検索条件
    group1.storedSearchConditions = store.state.search.qa
  })

  const group1 = reactive({

    // QA一覧画面に対する遷移元の名前
    fromNameForQAList: '',
    // 保存検索条件画面、検索履歴画面から遷移した時に保持される検索条件
    storedSearchConditions: null,
    
    /**
     * 親のビュー/コンポーネント名
     */
    parentName: computed(() => {
      return props.parentName
    }),

    /**
     * タブ1
     * 1=キーワード検索のタブ、2=AND/OR検索のタブ
     */
    tab1: 1,

    /**
     * タブ2
     * 1=パッケージを指定のタブ、2=書籍を指定のタブ、3=過去年度の書籍情報を指定のタブ
     */
    tab2: 1,

    /**
     * 関連法令を指定の単一指定/複数指定の切り替え
     * true=単一指定、false=複数指定
     */
    isSingleSearch: true,

    // ### 表示用 ###
    // パッケージを指定の選択肢リスト
    choices_packages: [],
    // 過去年度の書籍情報を指定の選択肢リスト
    choices_revisions_packages: [],

    // 検索タイプ
    search_type: 'keyword',

    // 検索キーワード(キーワード検索の場合)
    keyword_search_text: '',
    keyword_search_text_input: '', // データバインディング用
    
    // 表記の揺れを含む：0(曖昧検索),1(一致検索)
    is_fuzzy: 0,
    is_fuzzy_input: 0, // データバインディング用(キーワード検索の場合)
    andor_is_fuzzy_input: 0, // データバインディング用(AND/OR検索の場合)

    // 除外キーワード(キーワード検索の場合)
    keyword_excluding_text: '',
    
    // 検索キーワードリスト(AND/OR検索の場合)
    andor_search_texts: [{
      text1: '',
      text2: '',
      text3: '',
      text4: ''
    },
    {
      text1: '',
      text2: '',
      text3: '',
      text4: ''
    },
    {
      text1: '',
      text2: '',
      text3: '',
      text4: ''
    }],
    // 除外キーワードリスト(AND/OR検索の場合)
    andor_excluding_texts: [{
      text1: '',
      text2: '',
      text3: '',
      text4: ''
    }],

    // パッケージを指定：パッケージIDのリスト(v-model用)
    package_ids: [],
    // パッケージを指定：パッケージID → (パッケージID、パッケージ名、検索インデックID、リビジョン名) のデータ対応表
    // APIからのデータロード時にこの対応表にデータを登録し、その後のデータ対応表として使用する
    packageInfoMap: {},

    // パッケージを指定：パッケージリスト(ReadOnlyテキストエリア表示用)（SPで使用）
    packageNamesDisp: computed(() => {
      const packageNames = []
      for (let i = 0; i < group1.package_ids.length; i++) {
        const packageId = group1.package_ids[i]
        const key = 'package_' + packageId
        if (typeof group1.packageInfoMap[key] !== 'undefined') {
          packageNames.push(group1.packageInfoMap[key].package_name)
        }
      }
      let packageNamesDisp = packageNames.join('、')
      if (packageNamesDisp === '') {
        packageNamesDisp = 'パッケージは選択されていません。'
      }
      return packageNamesDisp
    }),

    // 書籍を指定：書籍リスト(ReadOnlyテキストエリア表示用)
    selectedBookNamesDisp: computed(() => {
      const bookNames = []
      const selectedBookList = group1.selectedBookList ?? []
      for (let i = 0; i < selectedBookList.length; i++) {
        if (selectedBookList[i].name !== '') {
          bookNames.push(selectedBookList[i].name)
        }
      }
      let selectedBookNamesDisp = bookNames.join('、')
      if (selectedBookNamesDisp === '') {
        selectedBookNamesDisp = '書籍は選択されていません。'
      }
      return selectedBookNamesDisp
    }),
    // 書籍を指定：書籍ID、書籍名のオブジェクトのリスト
    selectedBookList: [],

    // 過去年度の書籍情報を指定：パッケージIDとリビジョンIDをカンマで結合した文字列(v-model用)
    package_id_revision_id: '',
    // 過去年度の書籍情報を指定：パッケージID＆検索インデックID → (パッケージID、パッケージ名、検索インデックID、リビジョン名) のデータ対応表
    // APIからのデータロード時にこの対応表にデータを登録し、その後のデータ対応表として使用する
    revisionInfoMap: {},

    // 過去年度の書籍情報を指定：パッケージリスト(ReadOnlyテキストエリア表示用)（SPで使用）
    revisionNamesDisp: computed(() => {
      let revisionNames = ''
      if (group1.package_id_revision_id !== '') {
        const arr = group1.package_id_revision_id.split(',')
        const packageId = arr[0]
        const searchIndexId = arr[1]
        const key = 'package_' + packageId + ',revision_' + searchIndexId
        if (typeof group1.revisionInfoMap[key] !== 'undefined') {
          const packageName = group1.revisionInfoMap[key].package_name
          const revisionName = group1.revisionInfoMap[key].revision_name
          revisionNames = packageName + '：' + revisionName
        }
      }
      if (revisionNames === '') {
        revisionNames = '締め（年度）は選択されていません。'
      }
      return revisionNames
    }),

    // 関連法令(単一指定)
    laws_single: {
      title: '',
      article1: computed({
        get: () => group1.laws_single.article1_work,
        set: (value) => {
          if (!_.isNumber(value)) {
            value = Number(common.convertAsciiZ2H(value))
            if (isNaN(value) || value === 0) value = ''
          }
          group1.laws_single.article1_work = value
        }
      }),
      article2: computed({
        get: () => group1.laws_single.article2_work,
        set: (value) => {
          if (!_.isNumber(value)) {
            value = Number(common.convertAsciiZ2H(value))
            if (isNaN(value) || value === 0) value = ''
          }
          group1.laws_single.article2_work = value
        }
      }),
      article3: computed({
        get: () => group1.laws_single.article3_work,
        set: (value) => {
          if (!_.isNumber(value)) {
            value = Number(common.convertAsciiZ2H(value))
            if (isNaN(value) || value === 0) value = ''
          }
          group1.laws_single.article3_work = value
        }
      }),
      article4: computed({
        get: () => group1.laws_single.article4_work,
        set: (value) => {
          if (!_.isNumber(value)) {
            value = Number(common.convertAsciiZ2H(value))
            if (isNaN(value) || value === 0) value = ''
          }
          group1.laws_single.article4_work = value
        }
      }),
      article1_work: '', // computed作業用
      article2_work: '', // computed作業用
      article3_work: '', // computed作業用
      article4_work: '' // computed作業用
    }, 
    // 関連法令(複数指定)
    laws_multi: {
      group1: {
        title: '',
        article1: computed({
          get: () => group1.laws_multi.group1.article1_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group1.article1_work = value
          }
        }),
        article2: computed({
          get: () => group1.laws_multi.group1.article2_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group1.article2_work = value
          }
        }),
        article3: computed({
          get: () => group1.laws_multi.group1.article3_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group1.article3_work = value
          }
        }),
        article4: computed({
          get: () => group1.laws_multi.group1.article4_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group1.article4_work = value
          }
        }),
        article1_work: '', // computed作業用
        article2_work: '', // computed作業用
        article3_work: '', // computed作業用
        article4_work: '' // computed作業用
      },
      group1_ope: 'and',
      group2: {
        title: '',
        article1: computed({
          get: () => group1.laws_multi.group2.article1_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group2.article1_work = value
          }
        }),
        article2: computed({
          get: () => group1.laws_multi.group2.article2_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group2.article2_work = value
          }
        }),
        article3: computed({
          get: () => group1.laws_multi.group2.article3_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group2.article3_work = value
          }
        }),
        article4: computed({
          get: () => group1.laws_multi.group2.article4_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group2.article4_work = value
          }
        }),
        article1_work: '', // computed作業用
        article2_work: '', // computed作業用
        article3_work: '', // computed作業用
        article4_work: '' // computed作業用
      },
      group2_ope: 'or',
      group3: {
        title: '',
        from_article1: computed({
          get: () => group1.laws_multi.group3.from_article1_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.from_article1_work = value
          }
        }),
        from_article2: computed({
          get: () => group1.laws_multi.group3.from_article2_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.from_article2_work = value
          }
        }),
        from_article3: computed({
          get: () => group1.laws_multi.group3.from_article3_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.from_article3_work = value
          }
        }),
        from_article4: computed({
          get: () => group1.laws_multi.group3.from_article4_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.from_article4_work = value
          }
        }),
        to_article1: computed({
          get: () => group1.laws_multi.group3.to_article1_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.to_article1_work = value
          }
        }),
        to_article2: computed({
          get: () => group1.laws_multi.group3.to_article2_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.to_article2_work = value
          }
        }),
        to_article3: computed({
          get: () => group1.laws_multi.group3.to_article3_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.to_article3_work = value
          }
        }),
        to_article4: computed({
          get: () => group1.laws_multi.group3.to_article4_work,
          set: (value) => {
            if (!_.isNumber(value)) {
              value = Number(common.convertAsciiZ2H(value))
              if (isNaN(value) || value === 0) value = ''
            }
            group1.laws_multi.group3.to_article4_work = value
          }
        }),
        from_article1_work: '', // computed作業用
        from_article2_work: '', // computed作業用
        from_article3_work: '', // computed作業用
        from_article4_work: '', // computed作業用
        to_article1_work: '', // computed作業用
        to_article2_work: '', // computed作業用
        to_article3_work: '', // computed作業用
        to_article4_work: '' // computed作業用
      }
    }, 

    // 裁判情報
    judgement: {
      court_names: [], // 裁判所名（単一選択、複数選択に対応できるようリストで保持する）
      era: '',
      year: '',
      month: '',
      mday: '',
      restriction: 1,
      end_era: '',
      end_year: '',
      end_month: '',
      end_mday: ''
    },
    // 裁判情報(ReadOnlyテキストエリア表示用)
    judgementCourtNamesDisp: computed(() => {
      const courtNames = []
      for (let i = 0; i < group1.judgement.court_names.length; i++) {
        courtNames.push(group1.judgement.court_names[i])
      }
      let courtNamesDisp = courtNames.join('、')
      if (courtNamesDisp === '') {
        courtNamesDisp = '裁判所は選択されていません。'
      }
      return courtNamesDisp
    }),
    // 裁判年月日：元号(ラベル表示用)
    disp_judgement_era: computed(() => {
      return (group1.judgement.era === '') ? '選択' : group1.judgement.era
    }),
    // 裁判年月日：選択した元号に対する最終年
    disp_judgement_last_year_of_era: computed(() => {
      const lastYear = common.getLastYearOfEra(group1.judgement.era)
      if (group1.judgement.year > lastYear) {
        group1.judgement.year = lastYear
      }
      return lastYear
    }),
    // 裁判年月日：年(ラベル表示用)
    disp_judgement_year: computed(() => {
      const num = parseInt(group1.judgement.year)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return (num === 1) ? '元' : num
      }
    }),
    // 裁判年月日：月(ラベル表示用)
    disp_judgement_month: computed(() => {
      const num = parseInt(group1.judgement.month)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return num
      }
    }),
    // 裁判年月日：日(ラベル表示用)
    disp_judgement_mday: computed(() => {
      const num = parseInt(group1.judgement.mday)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return num
      }
    }),
    // 裁判年月日：指定(ラベル表示用)
    disp_judgement_restriction: computed(() => {
      let label = ''
      switch (parseInt(group1.judgement.restriction)) {
        case 1:
          label = '日指定'
          break
        case 2:
          label = '期間指定'
          break
        case 3:
          label = '指定日以降'
          break
        case 4:
          label = '指定日以前'
          break
      }
      return label
    }),
    // 裁判年月日：元号(ラベル表示用)
    disp_judgement_end_era: computed(() => {
      return (group1.judgement.end_era === '') ? '選択' : group1.judgement.end_era
    }),
    // 裁判年月日：選択した元号に対する最終年
    disp_judgement_end_last_year_of_era: computed(() => {
      const lastYear = common.getLastYearOfEra(group1.judgement.end_era)
      if (group1.judgement.end_year > lastYear) {
        group1.judgement.end_year = lastYear
      }
      return lastYear
    }),
    // 裁判年月日：年(ラベル表示用)
    disp_judgement_end_year: computed(() => {
      const num = parseInt(group1.judgement.end_year)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return (num === 1) ? '元' : num
      }
    }),
    // 裁判年月日：月(ラベル表示用)
    disp_judgement_end_month: computed(() => {
      const num = parseInt(group1.judgement.end_month)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return num
      }
    }),
    // 裁判年月日：日(ラベル表示用)
    disp_judgement_end_mday: computed(() => {
      const num = parseInt(group1.judgement.end_mday)
      if (_.isNaN(num) || num === '' || num === 0) {
        return '選択'
      } else {
        return num
      }
    }),    
    // 事件名
    case_name: '',

    // ### エラーメッセージ ###
    // エラー
    isError: false,

    // 関連法令(単一指定)
    error_laws_single: '',

    // 関連法令(複数指定)
    error_laws_multi_group1: '',
    error_laws_multi_group2: '',
    error_laws_multi_group3_from: '',
    error_laws_multi_group3_to: '',

    // 裁判年月日
    error_judgement_date: '',

    // 裁判年月日（まで）
    error_judgement_end_date: '',

    // 二重ロード防止フラグ
    isLoaded: false,

    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        if (!group1.isLoaded) {
          group1.isLoaded = true
          group1.loadData()
        }
      }
    }),

    /**
     * 表示用データをロードする
     */
    loadData: () => {
      
      if (
        group1.fromNameForQAList === 'PCHistoryOfSearch' ||
        group1.fromNameForQAList === 'SPHistoryOfSearch' ||
        group1.fromNameForQAList === 'PCSearchConditionList' ||
        group1.fromNameForQAList === 'SPSearchConditionList'
      ) {
        // 保存検索条件画面、検索履歴画面から遷移してきて表示した場合

        if (group1.storedSearchConditions) {
          // データをUIに復元する
          group1.restoreData(group1.storedSearchConditions, 2)
        }

        // 表示用データをロードする(ステップ２)
        group1.loadDataStep2()
      } else {
        // 通常の表示

        // 利用者設定取得APIをコール (QA詳細検索設定データを取得)
        const params = {}
        if (store.state.common.device === 'sp') {
          params.setting_key = 'sp_qa_detail_search_settings'
        } else {
          params.setting_key = 'pc_qa_detail_search_settings'
        }

        apiCommon.fetchUserSetting(params)
          .then(response => {
            if (response) {
              const { data } = response

              let data2 = null
              try {
                if (data.setting_value !== '') {
                  data2 = JSON.parse(data.setting_value)
                }
              } catch (e) {
              }

              if (data2) {
                // データをUIに復元する
                group1.restoreData(data2, 1)
              }

              // 表示用データをロードする(ステップ２)
              group1.loadDataStep2()
            }
          })
          .catch(e => {
            // システムエラー

            // 設定データが取得できなくても、表示用データはロードする
            // 表示用データをロードする(ステップ２)
            group1.loadDataStep2()
          })
      }
    },

    /**
     * データをUIに復元する
     * @param data2 データ
     * @param processType 処理タイプ(1=通常、2=保存検索条件画面、検索履歴画面から遷移)
     */
    restoreData: (data2, processType) => {

      if (
        typeof data2.search_type !== 'undefined' && 
        (data2.search_type === 'keyword' || data2.search_type === 'andor')
      ) {
        // データが存在する場合は、各値を設定する

        // タブ1（キーワード検索 / And/OR検索）の設定
        if (data2.search_type === 'andor') {
          group1.tab1 = 2 // 2=AND/OR検索
        } else {
          group1.tab1 = 1 // 1=キーワード検索
        }

        // ### 各種フォームデータの設定 ###

        // 表記揺れと、検索キーワード(キーワード検索の場合)は、
        // 現在ストアに保持されている簡易検索の設定を優先するため、
        // ここで、DB保存情報で設定しない。

        // 表記の揺れを含む (AND/OR検索の場合)
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」
          if (group1.tab1 === 2) {
            // 2=AND/OR検索
            group1.andor_is_fuzzy_input = data2.is_fuzzy ?? 0
          } else {
            // 1=キーワード検索
            group1.andor_is_fuzzy_input = 0 // デフォルト値
          }
        } else {
          // 処理タイプが「1=通常」
          group1.andor_is_fuzzy_input = data2.andor_is_fuzzy ?? 0
        }

        // 除外キーワード(キーワード検索の場合)
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」
          if (group1.tab1 === 2) {
            // 2=AND/OR検索
            // 設定しない
          } else {
            // 1=キーワード検索
            group1.keyword_excluding_text = data2.excluding_text ?? ''
          }
        } else {
          // 処理タイプが「1=通常」
          group1.keyword_excluding_text = data2.excluding_text ?? ''
        }

        // 検索キーワードリスト(AND/OR検索の場合)
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」は「1=通常」のキー名に変更
          data2.search_texts = data2.search_text
        }
        if (Array.isArray(data2.search_texts)) {
          for (let i = 0; i < data2.search_texts.length; i++) {
            if (typeof group1.andor_search_texts[i] !== 'undefined') {
              group1.andor_search_texts[i].text1 = data2.search_texts[i].or[0] ?? ''
              group1.andor_search_texts[i].text2 = data2.search_texts[i].or[1] ?? ''
              group1.andor_search_texts[i].text3 = data2.search_texts[i].or[2] ?? ''
              group1.andor_search_texts[i].text4 = data2.search_texts[i].or[3] ?? ''
            } else {
              const map = {
                text1: data2.search_texts[i].or[0] ?? '',
                text2: data2.search_texts[i].or[1] ?? '',
                text3: data2.search_texts[i].or[2] ?? '',
                text4: data2.search_texts[i].or[3] ?? ''
              }
              group1.andor_search_texts.push(map)
            }
          }
        }

        // 除外キーワードリスト(AND/OR検索の場合)
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」は「1=通常」のキー名に変更
          data2.excluding_texts = data2.excluding_text
        }
        if (Array.isArray(data2.excluding_texts)) {
          for (let i = 0; i < data2.excluding_texts.length; i++) {
            if (typeof group1.andor_excluding_texts[i] !== 'undefined') {
              group1.andor_excluding_texts[i].text1 = data2.excluding_texts[i].or[0] ?? ''
              group1.andor_excluding_texts[i].text2 = data2.excluding_texts[i].or[1] ?? ''
              group1.andor_excluding_texts[i].text3 = data2.excluding_texts[i].or[2] ?? ''
              group1.andor_excluding_texts[i].text4 = data2.excluding_texts[i].or[3] ?? ''
            } else {
              const map = {
                text1: data2.excluding_texts[i].or[0] ?? '',
                text2: data2.excluding_texts[i].or[1] ?? '',
                text3: data2.excluding_texts[i].or[2] ?? '',
                text4: data2.excluding_texts[i].or[3] ?? ''
              }
              group1.andor_excluding_texts.push(map)
            }
          }
        }

        // タブ２
        let tab2Work = 1 // 初期化
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」

          if (typeof data2.book_ids !== 'undefined') {
            // 「2=書籍を指定」
            tab2Work = 2
          } else {


            if (
              typeof data2.packages !== 'undefined' &&
              data2.packages.length === 1 &&
              typeof data2.packages[0].search_index_id !== 'undefined' &&
              data2.packages[0].search_index_id !== 0
            ) {
              // packagesの要素数が1つで、検索インデックスIDが0でない場合は「3=過去の世代を指定」
              // （保存検索条件画面、検索履歴画面から遷移した場合はこの処理になる）

              tab2Work = 3

              // 過去の世代を指定表示用の項目revisionsを生成
              const packageId = data2.packages[0].id
              const searchIndexId = data2.packages[0].search_index_id

              const revisions = []
              const map = {
                id: packageId,
                search_index_id: searchIndexId
              }
              revisions.push(map)
              data2.revisions = revisions
              data2.packages = []

            } else if (
              typeof data2.revisions !== 'undefined' &&
              data2.revisions.length === 1 &&
              typeof data2.revisions[0].search_index_id !== 'undefined' &&
              data2.revisions[0].search_index_id !== 0
            ) {
              // revisionsの要素数が1つで、検索インデックスIDが0でない場合は「3=過去の世代を指定」
              // （保存検索条件画面、検索履歴画面から遷移し、詳細検索ウィンドウを表示し、閉じてまた表示した場合はこの処理になる）

              tab2Work = 3
            
              // ここではrevisionsは設定されているので、revisionsを生成する処理は不要

            } else {
              // それ以外は「1=パッケージを指定」
              tab2Work = 1
            }
          }
        } else {
          // 処理タイプが「1=通常」
          if (typeof data2.tab2 !== 'undefined' && _.isNumber(data2.tab2)) {
            tab2Work = Number(data2.tab2)
          }
        }
        group1.tab2 = tab2Work

        // パッケージを指定：パッケージリスト
        // (パッケージID、パッケージ名、検索インデックID、リビジョン名のオブジェクトのリスト)
        const packages = data2.packages ?? []
        if (packages.length > 0) {
          const packageIdsWork = []
          for (let i = 0; i < packages.length; i++) {
            const packageId = packages[i].id
            packageIdsWork.push(packageId)
          }
          group1.package_ids = packageIdsWork
        }

        // 書籍を指定：書籍リスト
        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」
          const bookIds = data2.book_ids ?? []

          if (bookIds.length > 0) {

            // 書籍一覧APIをコール
            const params = {}
            params.search_range = 3 // キーワード検索対象範囲：3=QA
            params.book_ids = bookIds

            apiQA.listBooksForSearch(params)
              .then(response => {
                if (response) {
                  const { data } = response

                  const products = data.products ?? []

                  const bookNameMap = {}
                  for (let i = 0; i < products.length; i++) {
                    const _books = products[i].books
                    for (let k = 0; k < _books.length; k++) {
                      const bookId = _books[k].book_id
                      const bookName = _books[k].name
                      const key = 'book_' + bookId
                      bookNameMap[key] = bookName
                    }
                  }

                  const books = data.books ?? []
                  for (let i = 0; i < books.length; i++) {
                    const bookId = books[i].book_id
                    const bookName = books[i].name
                    const key = 'book_' + bookId
                    bookNameMap[key] = bookName
                  }

                  // 書籍ID、書籍名のオブジェクトのリストを生成
                  const selectedBookListWork = []
                  for (let i = 0; i < bookIds.length; i++) {
                    const bookId = bookIds[i]
                    const key = 'book_' + bookId
                    if (bookNameMap[key]) {
                      const bookName = bookNameMap[key]
                      const map = {
                        id: bookId,
                        name: bookName
                      }
                      selectedBookListWork.push(map)
                    }
                  }
                  group1.selectedBookList = selectedBookListWork
                }
              })
          }
        } else {
          // 「1=通常」
          const books = data2.books ?? []
          if (books.length > 0) {
            // 書籍ID、書籍名のオブジェクトのリスト
            group1.selectedBookList = books
          }
        }

        const revisions = data2.revisions ?? []
        if (revisions.length > 0) {
          // 過去の世代を指定：リビジョン
          const packageId = revisions[0].id
          const searchIndexId = revisions[0].search_index_id
          group1.package_id_revision_id = packageId + ',' + searchIndexId
        }

        // 関連法令
        const createLawsArticle = (value) => {
          return (typeof value === 'undefined' || _.isNaN(value) || value === 0) ? '' : value
        }

        if (data2.laws.type === 1) {
          group1.isSingleSearch = true
        } else if (data2.laws.type === 2) {
          group1.isSingleSearch = false
        }

        if (processType === 2) {
          // 処理タイプが「2=保存検索条件画面、検索履歴画面から遷移」
          if (data2.laws.type === 1) {
            // 1=単一指定
            group1.laws_single.title = data2.laws.title ?? ''
            group1.laws_single.article1 = createLawsArticle(data2.laws.article1)
            group1.laws_single.article2 = createLawsArticle(data2.laws.article2)
            group1.laws_single.article3 = createLawsArticle(data2.laws.article3)
            group1.laws_single.article4 = createLawsArticle(data2.laws.article4)
          } else {
            // 2=複数指定
            group1.laws_multi.group1.title = data2.laws.group1.title ?? ''
            group1.laws_multi.group1.article1 = createLawsArticle(data2.laws.group1.article1)
            group1.laws_multi.group1.article2 = createLawsArticle(data2.laws.group1.article2)
            group1.laws_multi.group1.article3 = createLawsArticle(data2.laws.group1.article3)
            group1.laws_multi.group1.article4 = createLawsArticle(data2.laws.group1.article4)
            if (data2.laws.group1_ope) {
              group1.laws_multi.group1_ope = data2.laws.group1_ope
            }
  
            group1.laws_multi.group2.title = data2.laws.group2.title ?? ''
            group1.laws_multi.group2.article1 = createLawsArticle(data2.laws.group2.article1)
            group1.laws_multi.group2.article2 = createLawsArticle(data2.laws.group2.article2)
            group1.laws_multi.group2.article3 = createLawsArticle(data2.laws.group2.article3)
            group1.laws_multi.group2.article4 = createLawsArticle(data2.laws.group2.article4)
            if (data2.laws.group2_ope) {
              group1.laws_multi.group2_ope = data2.laws.group2_ope
            }
  
            group1.laws_multi.group3.title = data2.laws.group3.title ?? ''
            group1.laws_multi.group3.from_article1 = createLawsArticle(data2.laws.group3.from_article1)
            group1.laws_multi.group3.from_article2 = createLawsArticle(data2.laws.group3.from_article2)
            group1.laws_multi.group3.from_article3 = createLawsArticle(data2.laws.group3.from_article3)
            group1.laws_multi.group3.from_article4 = createLawsArticle(data2.laws.group3.from_article4)
            group1.laws_multi.group3.to_article1 = createLawsArticle(data2.laws.group3.to_article1)
            group1.laws_multi.group3.to_article2 = createLawsArticle(data2.laws.group3.to_article2)
            group1.laws_multi.group3.to_article3 = createLawsArticle(data2.laws.group3.to_article3)
            group1.laws_multi.group3.to_article4 = createLawsArticle(data2.laws.group3.to_article4)
          }
        } else {
          // 処理タイプが「1=通常」
          // 1=単一指定
          group1.laws_single.title = data2.laws_single.title ?? ''
          group1.laws_single.article1 = createLawsArticle(data2.laws_single.article1)
          group1.laws_single.article2 = createLawsArticle(data2.laws_single.article2)
          group1.laws_single.article3 = createLawsArticle(data2.laws_single.article3)
          group1.laws_single.article4 = createLawsArticle(data2.laws_single.article4)

          // 2=複数指定
          group1.laws_multi.group1.title = data2.laws_multi.group1.title ?? ''
          group1.laws_multi.group1.article1 = createLawsArticle(data2.laws_multi.group1.article1)
          group1.laws_multi.group1.article2 = createLawsArticle(data2.laws_multi.group1.article2)
          group1.laws_multi.group1.article3 = createLawsArticle(data2.laws_multi.group1.article3)
          group1.laws_multi.group1.article4 = createLawsArticle(data2.laws_multi.group1.article4)
          if (data2.laws_multi.group1_ope) {
            group1.laws_multi.group1_ope = data2.laws_multi.group1_ope
          }

          group1.laws_multi.group2.title = data2.laws_multi.group2.title ?? ''
          group1.laws_multi.group2.article1 = createLawsArticle(data2.laws_multi.group2.article1)
          group1.laws_multi.group2.article2 = createLawsArticle(data2.laws_multi.group2.article2)
          group1.laws_multi.group2.article3 = createLawsArticle(data2.laws_multi.group2.article3)
          group1.laws_multi.group2.article4 = createLawsArticle(data2.laws_multi.group2.article4)
          if (data2.laws_multi.group2_ope) {
            group1.laws_multi.group2_ope = data2.laws_multi.group2_ope
          }

          group1.laws_multi.group3.title = data2.laws_multi.group3.title ?? ''
          group1.laws_multi.group3.from_article1 = createLawsArticle(data2.laws_multi.group3.from_article1)
          group1.laws_multi.group3.from_article2 = createLawsArticle(data2.laws_multi.group3.from_article2)
          group1.laws_multi.group3.from_article3 = createLawsArticle(data2.laws_multi.group3.from_article3)
          group1.laws_multi.group3.from_article4 = createLawsArticle(data2.laws_multi.group3.from_article4)
          group1.laws_multi.group3.to_article1 = createLawsArticle(data2.laws_multi.group3.to_article1)
          group1.laws_multi.group3.to_article2 = createLawsArticle(data2.laws_multi.group3.to_article2)
          group1.laws_multi.group3.to_article3 = createLawsArticle(data2.laws_multi.group3.to_article3)
          group1.laws_multi.group3.to_article4 = createLawsArticle(data2.laws_multi.group3.to_article4)
        }

        // 裁判情報
        const createJudgementYMD = (value) => {
          return (typeof value === 'undefined' || _.isNaN(value) || value === 0) ? '' : value
        }
        if (Array.isArray(data2.judgement.court_names)) {
          group1.judgement.court_names = data2.judgement.court_names
        }
        group1.judgement.era = data2.judgement.era ?? ''
        group1.judgement.year = createJudgementYMD(data2.judgement.year)
        group1.judgement.month = createJudgementYMD(data2.judgement.month)
        group1.judgement.mday = createJudgementYMD(data2.judgement.mday)
        if (data2.judgement.restriction) {
          group1.judgement.restriction = data2.judgement.restriction 
        }
        group1.judgement.end_era = data2.judgement.end_era ?? ''
        group1.judgement.end_year = createJudgementYMD(data2.judgement.end_year)
        group1.judgement.end_month = createJudgementYMD(data2.judgement.end_month)
        group1.judgement.end_mday = createJudgementYMD(data2.judgement.end_mday)

        // 事件名
        group1.case_name = data2.case_name ?? ''
      }

    },

    // パッケージを指定の選択肢リストロード完了フラグ
    isPackagesAndProductsLoaded: false,

    // 過去年度の書籍情報を指定の選択肢リストロード完了フラグ
    isRevisionsForChoiceLoaded: false,

    /**
     * 表示用データをロードする(ステップ２)
     */
    loadDataStep2: () => {

      // パッケージを指定の選択肢リストを生成
      // パッケージ・商品一覧APIをコール
      const params2 = {}
      params2.is_trial = 0 // 0=通常
      params2.is_only_contact = 1 // 1=契約商品のみ
      params2.search_range = 3 // キーワード検索対象範囲：3=QA

      apiQA.listPackagesAndProductsForSearch(params2)
        .then(response => {
          if (response) {
            const { data } = response

            const packages = data.packages ?? []

            group1.choices_packages = packages

            // データ対応表を生成する
            group1.packageInfoMap = {}
            for (let i = 0; i < packages.length; i++) {
              const packageId = packages[i].package_id
              const packageName = packages[i].name
              const key = 'package_' + packageId
              const map = {
                id: packageId,
                package_name: packageName,
                search_index_id: 0,
                revision_name: '最新'
              }
              group1.packageInfoMap[key] = map
            }
          }
        })
        .finally(() => {
          group1.isPackagesAndProductsLoaded = true
        })

      // 過去年度の書籍情報を指定の選択肢リストを生成
      // リビジョン一覧API（リビジョン選択用）をコール
      const params3 = {}

      apiQA.listRevisionsForChoice(params3)
        .then(response => {
          if (response) {
            const { data } = response

            const packages = data.packages ?? []
            group1.choices_revisions_packages = packages

            // データ対応表を生成する
            group1.revisionInfoMap = {}
            for (let i = 0; i < packages.length; i++) {
              const packageId = packages[i].id
              const packageName = packages[i].name
              for (let k = 0; k < packages[i].revisions.length; k++) {
                const searchIndexId = packages[i].revisions[k].id
                const revisionName = packages[i].revisions[k].name
                const key = 'package_' + packageId + ',revision_' + searchIndexId
                const map = {
                  id: packageId,
                  package_name: packageName,
                  search_index_id: searchIndexId,
                  revision_name: revisionName
                }
                group1.revisionInfoMap[key] = map
              }
            }

          }
        })
        .finally(() => {
          group1.isRevisionsForChoiceLoaded = true
        })
    },

    /**
     * タブ1を切り替える
     * @param {numeric} num 1=キーワード検索、2=AND/OR検索のタブ
     */
    changeTab1: (num) => {
      group1.tab1 = num
    },

    /**
     * タブ2を切り替える
     * @param {numeric} num 1=パッケージを指定、2=書籍を指定、3=過去年度の書籍情報を指定
     */
    changeTab2: (num) => {
      group1.tab2 = num
    },

    /**
     * AND/OR検索の検索キーワードの行を追加する
     */
    addSearchTextsRow: () => {
      group1.andor_search_texts.push({
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      })
    },

    /**
     * AND/OR検索の除外キーワードの行を追加する
     */
    addExcludingTextsRow: () => {
      group1.andor_excluding_texts.push({
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      })
    },

    /**
     * パッケージを指定の「指定をクリア」を押下した場合
     */
    clearPackageChoices: () => {
      group1.package_ids = []
    },

    /**
     * 書籍を指定の「指定をクリア」を押下した場合
     */
    clearBookChoices: () => {
      group1.selectedBookList = []
    },

    /**
     * 過去年度の書籍情報を指定の「指定をクリア」を押下した場合
     */
    clearRevisionChoices: () => {
      // 過去年度の書籍情報を指定：パッケージIDとリビジョンIDをカンマで結合した文字列(v-model用)
      group1.package_id_revision_id = ''
    },

    /**
     * 裁判情報を指定の「指定をクリア」を押下した場合
     */
    clearJudgementChoices: () => {
      group1.judgement.court_names = []
      group1.judgement.era = ''
      group1.judgement.year = ''
      group1.judgement.month = ''
      group1.judgement.mday = ''
      group1.judgement.restriction = 1
      group1.judgement.end_era = ''
      group1.judgement.end_year = ''
      group1.judgement.end_month = ''
      group1.judgement.end_mday = ''
      group1.case_name = ''
    },

    /**
     * 全ての検索条件をクリア
     */
    clearSearchCondition: () => {
 
      store.dispatch('qa/setIdMapListOfCheckedBooks', [])

      // 簡易検索の入力フォームをクリア
      if (context.parent.group1) {
        context.parent.group1.search_text_input = ''
        context.parent.group1.is_fuzzy_input = 0
      } else if (context.parent.search) {
        context.parent.search.search_text_input = ''
        context.parent.search.is_fuzzy_input = 0
      }

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: 'qa', searchText: '', isFuzzy: 0 })

      // タブ1(キーワード検索 / AND/OR検索)
      // ※タブ1(group1.tab1)は現状を維持することになったため、
      // 　ここでは初期値(1=キーワード検索)に設定しない。

      // タブ2（パッケージを指定 / 書籍を指定 / 過去の世代を指定）
      group1.tab2 = 1

      // 関連法令を指定の単一指定/複数指定の切り替え
      group1.isSingleSearch = true

      // 検索タイプ
      group1.search_type = 'keyword'
      // 表記の揺れを含む：初期状態はチェックあり(0=曖昧検索)
      group1.is_fuzzy_input = 0 
      group1.andor_is_fuzzy_input = 0 

      // 検索キーワード(キーワード検索の場合)
      group1.keyword_search_text_input = ''
      // 除外キーワード(キーワード検索の場合)
      group1.keyword_excluding_text = ''
        
      // 検索キーワードリスト(AND/OR検索の場合)
      group1.andor_search_texts = [{
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      },
      {
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      },
      {
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      }]
      // 除外キーワードリスト(AND/OR検索の場合)
      group1.andor_excluding_texts = [{
        text1: '',
        text2: '',
        text3: '',
        text4: ''
      }]

      // パッケージを指定：パッケージIDのリスト(v-model用)
      group1.package_ids = []

      // 書籍を指定
      group1.selectedBookList = []

      // 過去年度の書籍情報を指定：パッケージIDとリビジョンIDをカンマで結合した文字列(v-model用)
      group1.package_id_revision_id = ''

      // 関連法令(単一指定)
      group1.laws_single = {
        title: '',
        article1: '',
        article2: '',
        article3: '',
        article4: ''
      }
      // 関連法令(複数指定)
      group1.laws_multi = {
        group1: {
          title: '',
          article1: '',
          article2: '',
          article3: '',
          article4: ''
        },
        group1_ope: 'and',
        group2: {
          title: '',
          article1: '',
          article2: '',
          article3: '',
          article4: ''
        },
        group2_ope: 'or',
        group3: {
          title: '',
          from_article1: '',
          from_article2: '',
          from_article3: '',
          from_article4: '',
          to_article1: '',
          to_article2: '',
          to_article3: '',
          to_article4: ''
        }
      } 

      // 裁判情報
      group1.judgement = {
        court_names: [], // 裁判所名（単一選択、複数選択に対応できるようリストで保持する）
        era: '',
        year: '',
        month: '',
        mday: '',
        restriction: 1,
        end_era: '',
        end_year: '',
        end_month: '',
        end_mday: ''
      }

      // 事件名
      group1.case_name = ''

      
      // 利用者設定更新APIをコール (QA詳細検索設定データを保存)
      const params = {}
      if (store.state.common.device === 'sp') {
        params.setting_key = 'sp_qa_detail_search_settings'
      } else {
        params.setting_key = 'pc_qa_detail_search_settings'
      }
      params.setting_value = '' // クリア

      apiCommon.updateUserSetting(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 詳細検索実行フラグをfalseに設定
            store.dispatch('qa/setSearchDetail', false)
            // ストアに保持していた検索条件をクリア
            store.dispatch('search/setQASearchExtractParam', {})
            store.dispatch('search/setQASearchParam', {})

            if (props.parentName === 'PCQAList' || props.parentName === 'SPQAList') {
              // QA一覧画面で実行された場合、検索を実行する(一覧をリロードする)
              const isResetSearchCondition = true
              const options = {
                search_executed: true,
                is_reset: true
              }
              context.emit('searchDetail', options)
            } else if ( 
              (props.parentName === 'PCMenu' && props.parentNameOfMenu === 'PCQAList') ||
              (props.parentName === 'SPMenu' && props.parentNameOfMenu === 'SPQAList')
            ) {
              // QA一覧画面のメニューで実行された場合、検索を実行する(一覧をリロードする)
              const options = {
                search_executed: true,
                is_reset: true
              }
              context.emit('searchDetail', options)
            }
          }
        })
    },

    /**
     * この検索条件で検索するボタンを押下した場合
     */
    search: () => {

      const searchCategory = store.state.search.searchCategory

      if (group1.tab1 === 1) {
        // 1=キーワード検索のタブを選択している場合

        // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
        // 同画面で検索の場合用の設定
        store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: group1.keyword_search_text_input, isFuzzy: group1.is_fuzzy_input })
        // 別画面に遷移して検索する場合用の設定
        store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: searchCategory, searchText: group1.keyword_search_text_input, isFuzzy: group1.is_fuzzy_input })
      } else if (group1.tab1 === 2) {
        // 2=AND/OR検索のタブを選択している場合

        // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
        // 同画面で検索の場合用の設定
        store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
        // 別画面に遷移して検索する場合用の設定
        store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: searchCategory, searchText: '', isFuzzy: 0 })
      }

      // 簡易検索の曖昧フラグを初期化
      store.dispatch('qa/setIdMapListOfCheckedBooks', [])
      
      // ### 入力内容保持用データとQA詳細検索設定データ(JSON)を生成 ###
      // 入力内容保存用データ
      const inputData = {}
      // 検索用データ
      const searchData = {}

      // ### タブ1 (キーワード検索 / AND/OR検索) ###
      // 選択したタブ情報も利用者設定に保存しておく
      inputData.tab1 = group1.tab1
      searchData.tab1 = group1.tab1

      // 検索キーワードリスト(AND/OR検索の場合)
      const andOrSearchTexts = []
      for (let i = 0; i < group1.andor_search_texts.length; i++) {
        // 4つのテキストフィールドの入力内容で空でない値のみ前に詰めて配列化する
        const texts = []
        if (group1.andor_search_texts[i].text1 !== '') {
          texts.push(group1.andor_search_texts[i].text1)
        }
        if (group1.andor_search_texts[i].text2 !== '') {
          texts.push(group1.andor_search_texts[i].text2)
        }
        if (group1.andor_search_texts[i].text3 !== '') {
          texts.push(group1.andor_search_texts[i].text3)
        }
        if (group1.andor_search_texts[i].text4 !== '') {
          texts.push(group1.andor_search_texts[i].text4)
        }
        if (texts.length > 0) {
          const map = {
            or: texts
          }
          andOrSearchTexts.push(map)
        }
      }
      // 除外キーワードリスト(AND/OR検索の場合)
      const andOrExcludingTexts = []
      for (let i = 0; i < group1.andor_excluding_texts.length; i++) {
        // 4つのテキストフィールドの入力内容で空でない値のみ前に詰めて配列化する
        const texts = []
        if (group1.andor_excluding_texts[i].text1 !== '') {
          texts.push(group1.andor_excluding_texts[i].text1)
        }
        if (group1.andor_excluding_texts[i].text2 !== '') {
          texts.push(group1.andor_excluding_texts[i].text2)
        }
        if (group1.andor_excluding_texts[i].text3 !== '') {
          texts.push(group1.andor_excluding_texts[i].text3)
        }
        if (group1.andor_excluding_texts[i].text4 !== '') {
          texts.push(group1.andor_excluding_texts[i].text4)
        }
        if (texts.length > 0) {
          const map = {
            or: texts
          }
          andOrExcludingTexts.push(map)
        }
      }

      // 入力内容保持用データ
      // 検索タイプ
      if (group1.tab1 === 1) {
        inputData.search_type = 'keyword'
      } else if (group1.tab1 === 2) {
        inputData.search_type = 'andor'
      }

      // 表記の揺れを含む
      inputData.is_fuzzy = group1.is_fuzzy_input
      inputData.andor_is_fuzzy = group1.andor_is_fuzzy_input

      // 検索キーワード(キーワード検索の場合)
      inputData.search_text = group1.keyword_search_text_input
      // 除外キーワード(キーワード検索の場合)
      inputData.excluding_text = group1.keyword_excluding_text
      // 検索キーワードリスト(AND/OR検索の場合)
      inputData.search_texts = andOrSearchTexts
      // 検索キーワードリスト(AND/OR検索の場合)
      inputData.excluding_texts = andOrExcludingTexts

      // 検索用データ
      if (group1.tab1 === 1) {
        // 1=キーワード検索のタブを選択している場合

        // 表記の揺れを含む
        searchData.is_fuzzy = group1.is_fuzzy_input

        // 検索タイプ
        searchData.search_type = 'keyword'
        // 検索キーワード(キーワード検索の場合)
        searchData.search_text = group1.keyword_search_text_input
        // 除外キーワード(キーワード検索の場合)
        searchData.excluding_text = group1.keyword_excluding_text

      } else if (group1.tab1 === 2) {
        // 2=AND/OR検索のタブを選択している場合
        
        // 表記の揺れを含む
        searchData.is_fuzzy = group1.andor_is_fuzzy_input

        // 検索タイプ
        searchData.search_type = 'andor'
        // 検索キーワードリスト(AND/OR検索の場合)
        searchData.search_texts = andOrSearchTexts
        // 検索キーワードリスト(AND/OR検索の場合)
        searchData.excluding_texts = andOrExcludingTexts
      }

      // ### タブ2 (パッケージを検索 / 書籍を検索 / 過去の世代を検索) ###
      // 選択したタブ情報も利用者設定に保存しておく
      inputData.tab2 = group1.tab2
      searchData.tab2 = group1.tab2

      // パッケージを指定
      // ※パッケージの検索はパッケージIDあり＆検索インデックスIDなしのリスト（複数OK）
      const packageListOfSelectPackage = []
      const packageIds = group1.package_ids
      for (let i = 0; i < packageIds.length; i++) {
        const packageId = packageIds[i]
        const key = 'package_' + packageId
        if (typeof group1.packageInfoMap[key] !== 'undefined') {
          packageListOfSelectPackage.push(group1.packageInfoMap[key])
        }
      }

      // 書籍を指定
      const bookListOfSelectBook = []
      const selectedBookList = group1.selectedBookList ?? []
      for (let i = 0; i < selectedBookList.length; i++) {
        bookListOfSelectBook.push(selectedBookList[i])
      }

      // 過去の世代を指定
      // ※パッケージIDと検索インデックスIDのセットで検索はリストは1件のみ（複数NG）
      const packageListOfSelectRevision = []
      if (group1.package_id_revision_id !== '') {
        const arr = group1.package_id_revision_id.split(',')
        const packageId = arr[0]
        const searchIndexId = arr[1]
        const key = 'package_' + packageId + ',revision_' + searchIndexId
        if (typeof group1.revisionInfoMap[key] !== 'undefined') {
          packageListOfSelectRevision.push(group1.revisionInfoMap[key])
        }
      }

      inputData.packages = packageListOfSelectPackage
      inputData.books = bookListOfSelectBook
      inputData.revisions = packageListOfSelectRevision

      if (group1.tab2 === 1) {
        // 1=パッケージを指定のタブを選択している場合
        searchData.packages = packageListOfSelectPackage
      } else if (group1.tab2 === 2) {
        // 2=書籍を指定のタブを選択している場合
        searchData.books = bookListOfSelectBook
      } else if (group1.tab2 === 3) {
        // 3=過去年度の書籍情報を指定のタブを選択している場合
        searchData.packages = packageListOfSelectRevision
      }

      // ### 関連法令 ###
      const createLawsArticle = (value) => {
        return (typeof value === 'undefined' || _.isNaN(value) || value === '') ? 0 : value
      }

      // 単一指定
      const singleOfLawsMap = {}
      singleOfLawsMap.title = group1.laws_single.title
      singleOfLawsMap.article1 = createLawsArticle(group1.laws_single.article1)
      singleOfLawsMap.article2 = createLawsArticle(group1.laws_single.article2)
      singleOfLawsMap.article3 = createLawsArticle(group1.laws_single.article3)
      singleOfLawsMap.article4 = createLawsArticle(group1.laws_single.article4)

      // 複数指定
      const multiOfLawsMap = {}
      multiOfLawsMap.group1 = {}
      multiOfLawsMap.group1.title = group1.laws_multi.group1.title
      multiOfLawsMap.group1.article1 = createLawsArticle(group1.laws_multi.group1.article1)
      multiOfLawsMap.group1.article2 = createLawsArticle(group1.laws_multi.group1.article2)
      multiOfLawsMap.group1.article3 = createLawsArticle(group1.laws_multi.group1.article3)
      multiOfLawsMap.group1.article4 = createLawsArticle(group1.laws_multi.group1.article4)
      multiOfLawsMap.group1_ope = group1.laws_multi.group1_ope

      multiOfLawsMap.group2 = {}
      multiOfLawsMap.group2.title = group1.laws_multi.group2.title
      multiOfLawsMap.group2.article1 = createLawsArticle(group1.laws_multi.group2.article1)
      multiOfLawsMap.group2.article2 = createLawsArticle(group1.laws_multi.group2.article2)
      multiOfLawsMap.group2.article3 = createLawsArticle(group1.laws_multi.group2.article3)
      multiOfLawsMap.group2.article4 = createLawsArticle(group1.laws_multi.group2.article4)
      multiOfLawsMap.group2_ope = group1.laws_multi.group2_ope

      multiOfLawsMap.group3 = {}
      multiOfLawsMap.group3.title = group1.laws_multi.group3.title
      multiOfLawsMap.group3.from_article1 = createLawsArticle(group1.laws_multi.group3.from_article1)
      multiOfLawsMap.group3.from_article2 = createLawsArticle(group1.laws_multi.group3.from_article2)
      multiOfLawsMap.group3.from_article3 = createLawsArticle(group1.laws_multi.group3.from_article3)
      multiOfLawsMap.group3.from_article4 = createLawsArticle(group1.laws_multi.group3.from_article4)
      multiOfLawsMap.group3.to_article1 = createLawsArticle(group1.laws_multi.group3.to_article1)
      multiOfLawsMap.group3.to_article2 = createLawsArticle(group1.laws_multi.group3.to_article2)
      multiOfLawsMap.group3.to_article3 = createLawsArticle(group1.laws_multi.group3.to_article3)
      multiOfLawsMap.group3.to_article4 = createLawsArticle(group1.laws_multi.group3.to_article4)

      inputData.laws_single = singleOfLawsMap
      inputData.laws_multi = multiOfLawsMap
      inputData.laws = {}
      if (group1.isSingleSearch) {
        // true=単一指定を選択している場合
        inputData.laws.type = 1 // 1=単一指定
      } else {
        // false=複数指定を選択している場合
        inputData.laws.type = 2 // 2=複数指定
      }

      if (group1.isSingleSearch) {
        // true=単一指定を選択している場合
        searchData.laws = singleOfLawsMap
        // 指定タイプ
        searchData.laws.type = 1 // 1=単一指定
      } else {
        // false=複数指定を選択している場合
        searchData.laws = multiOfLawsMap
        // 指定タイプ
        searchData.laws.type = 2 // 2=複数指定
      }

      // ### 裁判情報 ###
      const createJudgementYMD = (value) => {
        return (typeof value === 'undefined' || _.isNaN(value) || value === '') ? 0 : value
      }

      const judgementMap = {}
      judgementMap.court_names = group1.judgement.court_names
      judgementMap.era = group1.judgement.era
      judgementMap.year = createJudgementYMD(group1.judgement.year)
      judgementMap.month = createJudgementYMD(group1.judgement.month)
      judgementMap.mday = createJudgementYMD(group1.judgement.mday)
      judgementMap.restriction = createJudgementYMD(group1.judgement.restriction)
      judgementMap.end_era = group1.judgement.end_era
      judgementMap.end_year = createJudgementYMD(group1.judgement.end_year)
      judgementMap.end_month = createJudgementYMD(group1.judgement.end_month)
      judgementMap.end_mday = createJudgementYMD(group1.judgement.end_mday)

      inputData.judgement = judgementMap
      searchData.judgement = judgementMap

      // ### 事件名 ###
      inputData.case_name = group1.case_name
      searchData.case_name = group1.case_name

      // ### 入力チェック ###
      let isError = false

      // エラーメッセージの初期化
      group1.error_laws_single = ''
      group1.error_laws_multi_group1 = ''
      group1.error_laws_multi_group2 = ''
      group1.error_laws_multi_group3_from = ''
      group1.error_laws_multi_group3_to = ''
      group1.error_judgement_date = ''
      group1.error_judgement_end_date = ''


      if (group1.isSingleSearch) {
        // 関連法令(単一指定)
        if (
          (searchData.laws.article1 === 0 && (searchData.laws.article2 !== 0 || searchData.laws.article3 !== 0 || searchData.laws.article4 !== 0)) ||
          (searchData.laws.article2 === 0 && (searchData.laws.article3 !== 0 || searchData.laws.article4 !== 0)) ||
          (searchData.laws.article3 === 0 && searchData.laws.article4 !== 0)
        ) {
          group1.error_laws_single = '正しく入力してください。'
          isError = true
        }
      } else {
        // 関連法令(複数指定)
        if (
          (searchData.laws.group1.article1 === 0 && (searchData.laws.group1.article2 !== 0 || searchData.laws.group1.article3 !== 0 || searchData.laws.group1.article4 !== 0)) ||
          (searchData.laws.group1.article2 === 0 && (searchData.laws.group1.article3 !== 0 || searchData.laws.group1.article4 !== 0)) ||
          (searchData.laws.group1.article3 === 0 && searchData.laws.group1.article4 !== 0)
        ) {
          group1.error_laws_multi_group1 = '正しく入力してください。'
          isError = true
        }

        if (
          (searchData.laws.group2.article1 === 0 && (searchData.laws.group2.article2 !== 0 || searchData.laws.group2.article3 !== 0 || searchData.laws.group2.article4 !== 0)) ||
          (searchData.laws.group2.article2 === 0 && (searchData.laws.group2.article3 !== 0 || searchData.laws.group2.article4 !== 0)) ||
          (searchData.laws.group2.article3 === 0 && searchData.laws.group2.article4 !== 0)
        ) {
          group1.error_laws_multi_group2 = '正しく入力してください。'
          isError = true
        }

        if (
          (searchData.laws.group3.from_article1 === 0 && (searchData.laws.group3.from_article2 !== 0 || searchData.laws.group3.from_article3 !== 0 || searchData.laws.group3.from_article4 !== 0)) ||
          (searchData.laws.group3.from_article2 === 0 && (searchData.laws.group3.from_article3 !== 0 || searchData.laws.group3.from_article4 !== 0)) ||
          (searchData.laws.group3.from_article3 === 0 && searchData.laws.group3.from_article4 !== 0)
        ) {
          group1.error_laws_multi_group3_from = '正しく入力してください。'
          isError = true
        }

        if (
          (searchData.laws.group3.to_article1 === 0 && (searchData.laws.group3.to_article2 !== 0 || searchData.laws.group3.to_article3 !== 0 || searchData.laws.group3.to_article4 !== 0)) ||
          (searchData.laws.group3.to_article2 === 0 && (searchData.laws.group3.to_article3 !== 0 || searchData.laws.group3.to_article4 !== 0)) ||
          (searchData.laws.group3.to_article3 === 0 && searchData.laws.group3.to_article4 !== 0)
        ) {
          group1.error_laws_multi_group3_to = '正しく入力してください。'
          isError = true
        }
      }

      // 裁判年月日
      if (searchData.judgement.era !== '' || searchData.judgement.year !== 0 || searchData.judgement.month !== 0 || searchData.judgement.mday !== 0) {
        // 元号・年・月・日のいずれかが入力されている
        if (searchData.judgement.era !== '' && searchData.judgement.year !== 0 && searchData.judgement.month !== 0 && searchData.judgement.mday !== 0) {
          // 元号・年・月・日が入力されている
          const isOK = validation.checkEraYearMonthMday(searchData.judgement.era, searchData.judgement.year, searchData.judgement.month, searchData.judgement.mday)
          if (!isOK) {
            group1.error_judgement_date = '存在する元号・年・月・日の組み合わせを入力してください。'
            isError = true
          }
        } else if (searchData.judgement.era !== '' && searchData.judgement.year !== 0 && searchData.judgement.month !== 0 && searchData.judgement.mday === 0) {
          // 元号・年・月が入力されている
          const isOK = validation.checkEraYearMonth(searchData.judgement.era, searchData.judgement.year, searchData.judgement.month)
          if (!isOK) {
            group1.error_judgement_date = '存在する元号・年・月の組み合わせを入力してください。'
            isError = true
          }
        } else if (searchData.judgement.era !== '' && searchData.judgement.year !== 0 && searchData.judgement.month === 0 && searchData.judgement.mday === 0) {
          // 元号・年が入力されている
          const isOK = validation.checkEraYear(searchData.judgement.era, searchData.judgement.year)
          if (!isOK) {
            group1.error_judgement_date = '存在する元号・年の組み合わせを入力してください。'
            isError = true
          }
        } else {
          // 元号・年・月・日の入力がおかしい
          group1.error_judgement_date = '存在する元号・年・月・日の組み合わせを入力してください。'
          isError = true
        }
      }

      if (searchData.judgement.restriction === 2) {
        // 「2=期間指定」の場合

        // 裁判年月日（まで）
        if (searchData.judgement.end_era !== '' || searchData.judgement.end_year !== 0 || searchData.judgement.end_month !== 0 || searchData.judgement.end_mday !== 0) {
          // 元号・年・月・日のいずれかが入力されている
          if (searchData.judgement.end_era !== '' && searchData.judgement.end_year !== 0 && searchData.judgement.end_month !== 0 && searchData.judgement.end_mday !== 0) {
            // 元号・年・月・日が入力されている
            const isOK = validation.checkEraYearMonthMday(searchData.judgement.end_era, searchData.judgement.end_year, searchData.judgement.end_month, searchData.judgement.end_mday)
            if (!isOK) {
              group1.error_judgement_end_date = '存在する元号・年・月・日の組み合わせを入力してください。'
              isError = true
            }
          } else if (searchData.judgement.end_era !== '' && searchData.judgement.end_year !== 0 && searchData.judgement.end_month !== 0 && searchData.judgement.end_mday === 0) {
            // 元号・年・月が入力されている
            const isOK = validation.checkEraYearMonth(searchData.judgement.end_era, searchData.judgement.end_year, searchData.judgement.end_month)
            if (!isOK) {
              group1.error_judgement_end_date = '存在する元号・年・月の組み合わせを入力してください。'
              isError = true
            }
          } else if (searchData.judgement.end_era !== '' && searchData.judgement.end_year !== 0 && searchData.judgement.end_month === 0 && searchData.judgement.end_mday === 0) {
            // 元号・年が入力されている
            const isOK = validation.checkEraYear(searchData.judgement.end_era, searchData.judgement.end_year)
            if (!isOK) {
              group1.error_judgement_end_date = '存在する元号・年の組み合わせを入力してください。'
              isError = true
            }
          } else {
            // 元号・年・月・日の入力がおかしい
            group1.error_judgement_end_date = '存在する元号・年・月・日の組み合わせを入力してください。'
            isError = true
          }
        }
      }

      if (searchData.judgement.restriction === 1) {
        // 「1=日指定」の場合
        // 「日指定」はデフォルトの選択であるため、全項目未入力の場合は必須チェックはしない（未設定と判断する）
        
        if (searchData.judgement.era !== '' || searchData.judgement.year !== 0 || searchData.judgement.month !== 0 || searchData.judgement.mday !== 0) {
          // 元号・年・月・日のいずれかが入力されている
          if (!(searchData.judgement.era !== '' && searchData.judgement.year !== 0 && searchData.judgement.month !== 0 && searchData.judgement.mday !== 0)) {
            // 日指定の場合は全項目入力である。
            group1.error_judgement_date = '日指定の場合は、元号・年・月・日をすべて入力してください。'
            isError = true
          }
        }
      } else if (searchData.judgement.restriction === 2) {
        // 「2=期間指定」の場合
        if (group1.error_judgement_date === '' && group1.error_judgement_end_date === '') {
          // 上記チェックで裁判年月日（から）と裁判年月日（まで）のエラーが無い場合
          if (
            (searchData.judgement.year === 0 && searchData.judgement.month === 0 && searchData.judgement.mday === 0) ||
            (searchData.judgement.end_year === 0 && searchData.judgement.end_month === 0 && searchData.judgement.end_mday === 0) 
          ) {
            group1.error_judgement_end_date = '期間指定の場合は、開始日と終了日の両方を入力してください。'
            isError = true
          }
        }

        if (group1.error_judgement_date === '' && group1.error_judgement_end_date === '') {
          // 上記チェックで裁判年月日（から）と裁判年月日（まで）が無い場合
          // 裁判年月日（から）＜ 裁判年月日（まで）のチェックをする
          if (
            (searchData.judgement.year !== 0 || searchData.judgement.month !== 0 || searchData.judgement.mday !== 0) &&
            (searchData.judgement.end_year !== 0 || searchData.judgement.end_month !== 0 || searchData.judgement.end_mday !== 0) 
          ) {
            // 裁判年月日（から）と裁判年月日（まで）が指定されている場合

            if (
              (searchData.judgement.year !== 0 && searchData.judgement.month !== 0 && searchData.judgement.mday !== 0) &&
              (searchData.judgement.end_year !== 0 && searchData.judgement.end_month !== 0 && searchData.judgement.end_mday !== 0) 
            ) {
              // 年・月・日が入力されている
              const gregorianStartYear = common.convertElaYearToGregorianYear(searchData.judgement.era, searchData.judgement.year)
              const gregorianEndYear = common.convertElaYearToGregorianYear(searchData.judgement.end_era, searchData.judgement.end_year)
              const startValue = gregorianStartYear * 10000 + searchData.judgement.month * 100 + searchData.judgement.mday
              const endValue = gregorianEndYear * 10000 + searchData.judgement.end_month * 100 + searchData.judgement.end_mday
              if (startValue > endValue) {
                group1.error_judgement_end_date = '開始日は終了日よりも過去を入力してください。'
                isError = true
              }
            } else if (
              (searchData.judgement.year !== 0 && searchData.judgement.month !== 0 && searchData.judgement.mday === 0) &&
              (searchData.judgement.end_year !== 0 && searchData.judgement.end_month !== 0 && searchData.judgement.end_mday === 0) 
            ) {
              // 年・月が入力されている
              const gregorianStartYear = common.convertElaYearToGregorianYear(searchData.judgement.era, searchData.judgement.year)
              const gregorianEndYear = common.convertElaYearToGregorianYear(searchData.judgement.end_era, searchData.judgement.end_year)
              const startValue = gregorianStartYear * 100 + searchData.judgement.month
              const endValue = gregorianEndYear * 100 + searchData.judgement.end_month
              if (startValue > endValue) {
                group1.error_judgement_end_date = '開始日は終了日よりも過去を入力してください。'
                isError = true
              }
            } else if (
              (searchData.judgement.year !== 0 && searchData.judgement.month === 0 && searchData.judgement.mday === 0) &&
              (searchData.judgement.end_year !== 0 && searchData.judgement.end_month === 0 && searchData.judgement.end_mday === 0) 
            ) {
              // 年が入力されている
              const gregorianStartYear = common.convertElaYearToGregorianYear(searchData.judgement.era, searchData.judgement.year)
              const gregorianEndYear = common.convertElaYearToGregorianYear(searchData.judgement.end_era, searchData.judgement.end_year)
              const startValue = gregorianStartYear
              const endValue = gregorianEndYear
              if (startValue > endValue) {
                group1.error_judgement_end_date = '開始日は終了日よりも過去を入力してください。'
                isError = true
              }
            } else {
              // 年・月・日の入力が、裁判年月日（から）と裁判年月日（まで）で揃っていない
              group1.error_judgement_end_date = '開始日と終了日で年月日の入力状態を揃えてください。'
              isError = true
            }
          }
        }
      }

      group1.isError = isError

      if (group1.isError) {
        // エラーがある場合
        return
      }


      // ストア保存用JSON生成
      const inputDataJson = JSON.stringify(inputData)

      // QA一覧APIの詳細検索用のリクエストパラメータを生成する
      const searchParams = logicCommonQA.createQAListParamsOfSearchDetails(searchData)
      
      // 検索条件をストアに保存
      store.dispatch('search/setQASearchExtractParam', searchParams)
      store.dispatch('search/setQASearchParam', searchParams)

      // 利用者設定更新APIをコール (QA詳細検索設定データを保存)
      const params = {}
      if (store.state.common.device === 'sp') {
        params.setting_key = 'sp_qa_detail_search_settings'
      } else {
        params.setting_key = 'pc_qa_detail_search_settings'
      }
      params.setting_value = inputDataJson

      apiCommon.updateUserSetting(params)
        .then(response => {
          if (response) {
            const { data } = response
      
            // QA一覧に対する遷移元の名前をクリア
            store.dispatch('qa/setFromNameForQAList', '')

            // 詳細検索実行フラグをtrueに設定
            store.dispatch('qa/setSearchDetail', true)
     
            // 詳細検索を実行する
            const options = {
              search_executed: true
            }
            context.emit('searchDetail', options)

            // 本ウィンドウを閉じる
            context.emit('closeSearchDetail')

            // メニューから表示された場合はメニューを閉じる
            context.emit('closeMenu')
          }
        })

    },

    /**
     * 裁判所リストを更新（裁判所選択ウィンドウから実行される）
     */
    updateCourtNames: (courtNames) => {
      group1.judgement.court_names = courtNames
    }

  })

  return group1
}
